import { SetStateAction } from "react";
import { IArticle } from "./IArticle";

export default class ArticleStore {
  static articles: any = [];
  static loading: boolean = false;
  static finished: boolean = false;
  static membersNames: any = [];
  static series: any = [];
  static citationsCount: any = [];

  private constructor() {}

  static async getInstance() {
    
    if (!this.loading && !this.finished) {
      await this.fetchArticles();
      await this.findUniqueMembers();
      await this.createSeries();
      
    }
  }

  static async getArticles(): Promise<SetStateAction<never[]>> {
    return this.articles;
  }

  static async getSeries(): Promise<SetStateAction<never[]>> {
    return this.series;
  }

  static async getCitations(): Promise<SetStateAction<never[]>> {
    return this.citationsCount;
  }

  static async getMemberNames(): Promise<SetStateAction<never[]>> {
    return this.membersNames;
  }

  static setArticles(articles: IArticle[]) {
    this.articles = articles;
  }

  static setLoading(loading: boolean) {
    this.loading = loading;
  }

  static setFinished(finished: boolean) {
    this.finished = finished;
  }

  static async findUniqueMembers() {
    await this.articles.forEach((article: IArticle) => {
      if (!this.membersNames.includes(article.staffMember)) {
        this.membersNames.push(article.staffMember);
      }
    });
  }

  static async countYearArticles(
    authorName: string,
    year: number
  ): Promise<number> {
    let count: number = 0;
    this.articles.forEach((article: IArticle) => {
      if (article.staffMember === authorName && article.year === year.toString()) {
        count++;
      }
    });
    return count;
  }

  static async countAuthorArticle(authorName: string): Promise<number> {
    let count: number = 0;
    this.articles.forEach((article: IArticle) => {
      if (article.staffMember === authorName) {
        count++;
      }
    });
    return count;
  }

   static async countAuthorCiation(authorName: string): Promise<number> {
    let count: number = 0;
    this.articles.forEach((article: IArticle) => {
      if (article.staffMember === authorName) {
        count += article.citations;
      }
    });
    return count;
  }

  static async countYearCitations(
    authorName: string,
    year: number
  ): Promise<number> {
    let count: number = 0;
    this.articles.forEach((article: IArticle) => {
      if (article.staffMember === authorName && article.year === year.toString()) {
        count += article.citations;
      }
    });
    return count;
  }

static async fetchArticles() {
  try {
    const response = await fetch(
      "https://research-article-getter.netlify.app/.netlify/functions/api//get_research_articles"
    );

    const data = await response.json();
   

    if (!Array.isArray(data)) {
      console.error("API did not return an array:", data);
      this.setArticles([]); // fallback to empty
      return;
    }

    this.setArticles(data);
    this.setLoading(true);
  } catch (err) {
    console.error("Error fetching articles:", err);
    this.setArticles([]); // prevent crash on failure
  }
}

  static async createSeries() {
    this.series = [];
    const currentYear = new Date().getFullYear();
    this.membersNames.forEach(async (member: string) => {
      let object: any = { memberName: member };
      object["Total of Last Five Years"] =
        await ArticleStore.countAuthorArticle(member);

      for (let index = currentYear; index > currentYear - 6; index--) {
        object[index] = await ArticleStore.countYearArticles(member, index);
      }
      this.series.push(object);
    });
    
    this.createCitations();
  }

   static async createCitations() {
    this.citationsCount  = [];
    const currentYear = new Date().getFullYear();
    this.membersNames.forEach(async (member: string) => {
      let object: any = { memberName: member };
      object["Total Citations of Last Five Years"] =
        await ArticleStore.countAuthorCiation(member);

      for (let index = currentYear; index > currentYear - 6; index--) {
        object[index] = await ArticleStore.countYearCitations(member, index);
      }
      this.citationsCount.push(object);
    });
    
    this.setFinished(true);
  }
}
